import React, { useState, useEffect, useRef } from 'react';
import './style.scss';
import GuideButton from './guideButton';
import ShareButton from './shareButton';
import PauseButton from './pauseButton';
import SoundButton from './soundButton';
const CedoraLayout = ({ scenes, currentPano, onSelectScene }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showWavingHand, setShowWavingHand] = useState(true);
  const menuContentRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeftPos, setScrollLeftPos] = useState(0);
  const [hasDragged, setHasDragged] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleScreenClick = () => {
    setShowWavingHand(false);
  };

  const handleSceneSelect = (scene) => {
    if (hasDragged) return;
    if (onSelectScene && scene.groupId) {
      onSelectScene(scene.groupId, scene.id);
    }
  };

  const handleWheel = (e) => {
    if (menuContentRef.current && e.deltaY !== 0) {
      menuContentRef.current.scrollLeft += e.deltaY;
    }
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setHasDragged(false);
    setStartX(e.pageX - menuContentRef.current.offsetLeft);
    setScrollLeftPos(menuContentRef.current.scrollLeft);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - menuContentRef.current.offsetLeft;
    const walk = (x - startX) * 1;
    if (Math.abs(walk) > 5) {
      setHasDragged(true);
    }
    menuContentRef.current.scrollLeft = scrollLeftPos - walk;
  };

  useEffect(() => {
    document.addEventListener('click', handleScreenClick);
    document.addEventListener('touchstart', handleScreenClick);
    document.addEventListener('mousedown', handleScreenClick);

    return () => {
      document.removeEventListener('click', handleScreenClick);
      document.removeEventListener('touchstart', handleScreenClick);
      document.removeEventListener('mousedown', handleScreenClick);
    };
  }, []);

  return (
    <div className="cedora-layout">
      <div className="header">
        <div className="header-title">
          <p>{`${currentPano?.title}`}</p>
        </div>
        <div className="header-overview-map">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.5 7.25782C2.5 6.02987 2.5 5.41589 2.8272 5.05779C2.94337 4.93065 3.08456 4.82889 3.24191 4.75888C3.6851 4.56172 4.26757 4.75587 5.43251 5.14418C6.32189 5.44064 6.76657 5.58887 7.21592 5.57353C7.38095 5.56789 7.54501 5.54592 7.70571 5.50794C8.14326 5.40451 8.53327 5.1445 9.31331 4.62448L10.4653 3.85649C11.4645 3.19036 11.9641 2.8573 12.5376 2.7805C13.111 2.7037 13.6807 2.89357 14.8199 3.27332L15.7906 3.59687C16.6156 3.87188 17.0281 4.00938 17.2641 4.33674C17.5 4.6641 17.5 5.09893 17.5 5.96858V12.7422C17.5 13.9702 17.5 14.5841 17.1728 14.9422C17.0566 15.0694 16.9154 15.1711 16.7581 15.2411C16.3149 15.4383 15.7324 15.2442 14.5675 14.8558C13.6781 14.5594 13.2334 14.4112 12.7841 14.4265C12.6191 14.4321 12.455 14.4541 12.2943 14.4921C11.8567 14.5955 11.4667 14.8555 10.6867 15.3756L9.53471 16.1435C8.53552 16.8097 8.03593 17.1427 7.46244 17.2195C6.88895 17.2963 6.31932 17.1065 5.18007 16.7267L4.20943 16.4032C3.38441 16.1281 2.97189 15.9906 2.73595 15.6633C2.5 15.3359 2.5 14.9011 2.5 14.0314V7.25782Z"
              stroke="white"
            ></path>
            <path d="M7.5 5.53223V17.0834" stroke="white"></path>
            <path d="M12.5 2.5V14.1667" stroke="white"></path>
          </svg>
        </div>
      </div>

      {/* Menu Content */}
      <div className={`bottom-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="menu-toggle-container">
          <button
            className={`menu-toggle-button ${isMenuOpen ? 'up' : ''}`}
            onClick={toggleMenu}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              className={`toggle-icon ${isMenuOpen ? 'rotate' : ''}`}
            >
              <path
                d="M7 10L12 15L17 10"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
        <div
          className={`menu-content ${isDragging ? 'dragging' : ''}`}
          ref={menuContentRef}
          onWheel={handleWheel}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          {scenes && scenes.length > 0 ? (
            scenes.map((scene, index) => (
              <button
                key={scene.id}
                type="button"
                className={`menu-item ${
                  currentPano?.id === scene.id ? 'active' : ''
                }`}
                onClick={() => handleSceneSelect(scene)}
                aria-label={`Select scene: ${scene.title}`}
                style={{
                  backgroundImage: scene.previewImgUrl
                    ? `url(${scene.previewImgUrl})`
                    : 'none',
                }}
              >
                <div className="scene-info">
                  <p>{scene.title}</p>
                </div>
              </button>
            ))
          ) : (
            <div className="no-scenes">
              <p>No scenes</p>
            </div>
          )}
        </div>
        <div className="menu-left">
          <GuideButton />
          <ShareButton />
          <SoundButton />
          <PauseButton />
        </div>
      </div>
      {showWavingHand && (
        <div className="waving-hand">
          <svg
            width="62"
            height="60"
            viewBox="0 0 62 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="waving-hand"
          >
            <path
              d="M43 21.642C42.897 24.0637 41.8249 35.4198 40.2176 37.42C37.31 41.036 38.5924 48.8683 38.9209 52.5004H21.9821C21.9821 51.0296 21.945 49.5509 21.9821 48.0814C22.0292 47.1344 21.982 40.9438 19.4158 39.0988C15.8503 36.5354 15.0077 30.129 13.9544 25.0947C13.7179 23.9723 13.0419 23.0058 12.6404 22.3387C12.3119 21.7928 11.9834 21.1324 11.1118 20.3008C10.5654 19.8117 9.90098 19.1826 10.0123 18.8211C10.6582 16.801 14.393 16.6103 15.8503 18.1609C16.3029 18.6395 16.5903 19.2214 16.8727 19.8172C17.3576 20.8572 17.8268 21.7847 18.3727 22.8029C18.6408 23.2301 18.9742 23.4581 19.4796 23.3216C19.9664 23.1845 20.1197 22.8194 20.1364 22.3387C20.1416 22.1333 20.178 20.8777 20.2187 19.0804C20.2343 18.4642 20.2512 17.792 20.2694 17.0731C20.3116 15.402 20.3644 13.4928 20.4213 11.6072C20.444 10.8931 20.4622 10.1742 20.4844 9.47877C20.567 6.75764 20.6528 4.27949 20.7218 2.83788C20.8172 0.897151 22.4198 -0.360527 24.2719 0.0931002C25.4682 0.380527 26.4779 1.43858 26.4333 3.20311C26.3956 4.51472 26.3334 7.16163 26.27 9.67305C26.2516 10.4013 26.2334 11.1202 26.2165 11.7924C26.1778 13.5057 26.1422 14.9154 26.1293 15.4289C26.5996 14.4693 27.2587 13.7668 28.2832 13.4986C29.6493 13.1411 30.9517 13.8283 31.5308 15.0062C31.7341 15.4224 31.8473 15.9064 31.8389 16.4247C31.8373 16.6722 31.8311 16.915 31.8203 17.1622C31.8085 17.629 31.7967 18.0959 31.7844 18.5813C32.0108 18.0826 32.2005 17.5643 32.555 17.1436C33.4178 16.1006 34.4483 15.7812 35.6128 16.2267C36.7359 16.657 37.4295 17.7164 37.3976 18.9768L37.3535 20.7226C37.4847 20.4971 38.3316 18.6129 40.6721 18.6819C40.9134 18.6974 41.1351 18.7498 41.3421 18.8345C42.4192 19.245 43.0447 20.424 42.9948 21.6653L43 21.642Z"
              fill="url(#paint0_linear_1071_1145)"
            ></path>
            <g clipPath="url(#clip0_1071_1145)">
              <path
                d="M49.2994 34.5V35.1905C55.2018 37.2794 58.9341 40.361 58.9341 43.7999C58.9341 49.616 48.2515 54.4135 34.4527 55.1075V58.0458C49.7033 57.3086 61.5565 51.7549 61.5565 45.0101C61.5565 40.7114 56.74 36.8945 49.2994 34.5017V34.5Z"
                fill="url(#paint1_linear_1071_1145)"
              ></path>
              <path
                d="M27.6042 55.1092C13.7796 54.4256 3.06582 49.6229 3.06582 43.7999C3.06582 40.3627 6.7982 37.2794 12.7006 35.1905V34.5C5.26001 36.8927 0.443481 40.7097 0.443481 45.0083C0.443481 51.7618 12.3277 57.3224 27.6042 58.0475V60L33.3875 56.6612L27.6042 53.3225V55.111V55.1092Z"
                fill="url(#paint2_linear_1071_1145)"
              ></path>
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_1071_1145"
                x1="26.5"
                y1="31.6985"
                x2="26.4768"
                y2="53.0589"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="white"></stop>
                <stop offset="1" stopColor="white" stopOpacity="0"></stop>
              </linearGradient>
              <linearGradient
                id="paint1_linear_1071_1145"
                x1="48.0046"
                y1="58.044"
                x2="48.0046"
                y2="34.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.27" stopColor="white"></stop>
                <stop offset="1" stopColor="white" stopOpacity="0.5"></stop>
              </linearGradient>
              <linearGradient
                id="paint2_linear_1071_1145"
                x1="16.9164"
                y1="60"
                x2="16.9164"
                y2="34.5"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.27" stopColor="white"></stop>
                <stop offset="1" stopColor="white" stopOpacity="0.5"></stop>
              </linearGradient>
              <clipPath id="clip0_1071_1145">
                <rect
                  width="61.113"
                  height="25.5"
                  fill="white"
                  transform="translate(0.443481 34.5)"
                ></rect>
              </clipPath>
            </defs>
          </svg>
          <p className="waving-hand-text">Click & drag to explore</p>
        </div>
      )}
    </div>
  );
};

export default CedoraLayout;
